export default {
  path: '/:pathMatch(.*)*',
  name: 'platform.loading',
  meta: {
    title: 'Loading Platform',
    layout: 'blank',
    requires: {
      project: false,
      user: false,
    },
    search: {
      show: false,
    },
  },
  component: () => import('./LoadingPage.vue'),
};
